import React from 'react';


const FirstStep = props => (
  <div className='fdvEquip-slides-item simpleSlide active'>
    <div className='card card-lg card-plain'>
      <p className='card-lg-title'>N° Pedidos</p>
      <div className='pillSelct-pills'>
        {props.pedidosEquiposAdicionales.map((pedido, id) => (
          pedido.status !== 0 ? (<label key={id} className='pill pill-cyan pillSelct-pills-item'>{pedido + ' '}
            <button className='pillSelct-delete'>
              {props.tipoLlamadaEquiposAdicionales==='1'?(<i className='icon ion-close pill-close' onClick={() => props.eliminarEquiposAdicionales(pedido)} />):null}
            </button>
          </label>
          ) : null
        ))}
      </div>
    </div>
    <div className='modal-actions'>
      <button className='btn btn-primary pull-right' onClick={props.nextStep}>Siguiente</button>
    </div>
  </div>
);

export default FirstStep;



// WEBPACK FOOTER //
// ./src/pages/modals/AgregarEquiposAdicionales/FirstStep.js